import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormGroup, ReactiveFormsModule} from '@angular/forms';
import {AppFocusNextIdDirective} from '../../../../../common/directive/app-focus-next-id.directive';

@Component({
  selector: 'app-form-input',
  imports: [
    ReactiveFormsModule,
    AppFocusNextIdDirective
  ],
  templateUrl: './input.component.html'
})
export class InputComponent {

  @Input()
  formGroup: FormGroup;

  @Input()
  type: string;

  @Input()
  autocomplete: string;

  @Input()
  name: string;

  @Input()
  label: string

  @Input()
  placeholder: string

  @Input()
  black = false;

  @Input()
  big = false

  @Input()
  showValidationErrors = true;

  @Input()
  tabIndex = 0

  @Input()
  autoFocus = false

  @Input()
  border = 3

  @Input()
  appFocusNextId: string

  @Output()
  onChange = new EventEmitter<string>()

}
